import { useState } from "react";
import { ButtonControl } from "../../common/components/controls/button";
import { FormPage } from "../../common/components/form_page";
import { InfoText } from "../../common/components/info_text";
import InformationFormContent from "../profile/edit/information-form-content";
import { CompanyIntro } from "../../common/components/company-intro";
import { useUser } from "../../common/hooks/User";
import { textChooser } from "../../common/util/textChooser";
import { Experience } from "../profile/edit/experience";
import { Academics } from "../profile/edit/academics";
import { Documents } from "../profile/edit/documents";
import { useOpportunity } from "../../common/hooks/Opportunities";
import { PhotoUpload } from "../profile/edit/photoUpload";
import { ImportantText } from "../../common/components/important_text";
import { LoadingPage } from "../../common/components/loading/loadingPage";

interface IOpportunitySkills {
  handleSubmit: () => void;
  renderOpportunityForm: any;
  isLoading: boolean;
  isError: boolean;
  errors: string[];
  opportunity: any;
  register: any;
  control: any;
  setValue: any;
  validateProfileError: boolean;
}

const initialGeoState = {
  address: "",
  city: "",
  district: "",
  location: "",
}

export default function OpportunitySkills({ 
  handleSubmit, 
  renderOpportunityForm, 
  isError, 
  isLoading, 
  errors, 
  register, 
  control, 
  setValue, 
  validateProfileError 
}: IOpportunitySkills) {
  
  const userData = useUser().getDataAll();
  const { opportunityData: data, isSuccess, isLoading: loading } = useOpportunity();
  const [ , opportunityData ] = data || [];

  const [geo, setGeo] = useState<any>({
    ...initialGeoState,
    ...userData.addresses[0],
  });

  const renderContent = () => (
    <section className="apply-section">
      <div className="apply-intro" style={{ marginBottom: 30 }}>
        <CompanyIntro jobName={opportunityData!.name} avatarUrl="" companyName="" />
        <p className="text sizeSm colorNavy">
          {isSuccess && opportunityData?.description}
        </p>
      </div>

      <section className="apply-container">
        <div className="apply-section">
          <div style={{marginBottom: "20px"}}>
            <ImportantText>
              <p className="text sizeSm">
                <strong>Llena y verifica toda la información que se solicita en el formulario</strong> para que puedas aplicar correctamente a la oportunidad.
              </p>
            </ImportantText>
          </div>

          <FormPage pageTitle={textChooser('txt77')}>
            <form>
              <InformationFormContent
                control={control}
                errors={errors}
                hasError={isError}
                register={register}
                userData={userData}
                geo={geo}
                setGeo={setGeo}
                setValue={setValue}
              />
            </form>
          </FormPage>

          <Experience />
          <Academics />
          <Documents />

          <FormPage
            pageTitle={textChooser("txt122")}
            pageDescription={textChooser("txt123")}
            className="skill-set-wrapper"
          >
            <form onSubmit={handleSubmit}>
              {renderOpportunityForm()}
            </form>
          </FormPage>

          <div className="row">
            <div className="col-xs-12" hidden={!isError}>
              <InfoText text={textChooser("txt141")} type="danger" />
            </div>
            <div className="col-xs-12" hidden={!errors.length}>
              <InfoText text={textChooser("txt174")} type="danger" />
            </div>
            <div className="col-xs-12" hidden={!validateProfileError}>
              <InfoText text={textChooser("txt183")} type="danger" />
            </div>
            <div className="col-xs-12" hidden={!errors.includes("validate-cv")}>
              <InfoText text={textChooser("txt197")} type="danger" />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-4">
              <ButtonControl
                type="button"
                onClick={handleSubmit}
                value={textChooser(isLoading ? "txt140" : "txt130")}
                disabled={isLoading}
                primary
                full
              />
            </div>
          </div>
        </div>
        <section className="profile-edit-col">
          <PhotoUpload />
        </section>
      </section>
    </section>
  )

  return (
    <div className="page -apply">
      {isSuccess && !isLoading ? renderContent() : <LoadingPage/>}
    </div>
  );
}